const get = require('lodash/get');

const clinicalSceneKeys = ['CLINIC', 'HOSPITAL', 'EMERGENCY_ROOM'];

function areAllScenesClinical(caseConf) {
  const sceneKeys = [
    get(caseConf, '_startLocation.key'),
    get(caseConf, '_endLocation.key'),
  ].filter(Boolean);
  return sceneKeys.length > 0 && sceneKeys.every(key => clinicalSceneKeys.includes(key));
}

module.exports = {
  clinicalSceneKeys,
  areAllScenesClinical,
};